import { memo, PropsWithChildren } from 'react';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent
} from '@/shadcn/hover-card';

type Props = PropsWithChildren<{
  title?: React.ReactNode;
  body: React.ReactNode;
  delay?: number;
}>;

export const TooltipWrapper = memo(
  ({ children, title, body, delay }: Props) => {
    return (
      <HoverCard openDelay={delay}>
        <HoverCardTrigger className="size-full" data-testid="tooltip-wrapper">
          {children}
        </HoverCardTrigger>
        <HoverCardContent className="max-w-[440px] min-w-[60px] px-5 py-2.5">
          {title && (
            <div className="border-border mb-1 border-b text-sm font-semibold">
              {title}
            </div>
          )}
          <div className="text-justify text-[13px]">{body}</div>
        </HoverCardContent>
      </HoverCard>
    );
  }
);
